import { render } from "./McqView.vue?vue&type=template&id=34b009b3"
import script from "./McqView.vue?vue&type=script&lang=js"
export * from "./McqView.vue?vue&type=script&lang=js"

import "@/assets/CSS/ProgressTracking.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__